import { render, staticRenderFns } from "./Columns.vue?vue&type=template&id=4121c338&scoped=true&"
import script from "./Columns.vue?vue&type=script&lang=ts&"
export * from "./Columns.vue?vue&type=script&lang=ts&"
import style0 from "./Columns.vue?vue&type=style&index=0&id=4121c338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121c338",
  null
  
)

export default component.exports